module.exports = __webpack_public_path__ + "static/img/16.3f3c580c.png";